import callAPI from "@helpers/network";
import { ServiceStatus } from "./services-status.services";

export const SERVICE_STATUS = {
  GET_SERVICE_STATUS: async () => {
    return callAPI(ServiceStatus.getServiceStatus());
  },
};
